import {ITableColumn, TBaseOrObservableOrFunctionArrayType, TBaseOrObservableType} from "../../index";
import {lm} from "../../appContext";
import {ISortableTableHeadingParams} from "./index";
import {IAllCheckbox} from "../search/th-checkbox";
import sortable_table_headingHtml from './sortable-table-heading.html?raw';

export let template: string = sortable_table_headingHtml;

export class viewModel {

    TABLE: TBaseOrObservableOrFunctionArrayType<ITableColumn>;
    sortcol: KnockoutObservable<string>;
    asc: KnockoutObservable<boolean>;
    private isSortableColumn: (col: ITableColumn) => boolean;
    private translate: (key: string) => TBaseOrObservableType<string>;
    private getHeaderTitle: (data: any) => string;
    private allCheckbox: IAllCheckbox<any> | undefined;

    constructor(private params: ISortableTableHeadingParams) {
        this.TABLE = params.TABLE;
        this.allCheckbox = params.allCheckbox
        this.sortcol = params.sortcol;
        this.asc = params.asc;
        this.isSortableColumn = params.isSortableColumn;
        this.translate = params.translate ?? ((key: string) => lm.t(key) ?? key)
        this.getHeaderTitle = params.getHeaderTitle
    }

    getCellCss(item: ITableColumn) {
        let css = ["cell", "cell__" + (item.key as any)];
        if (item.sort || this.isSortableColumn && this.isSortableColumn(item)) {
            css.push("cell--sortable");
        }
        if (item.center || item.count) {
            css.push('text-center');
        }
        if ('css' in item && item.css) {
            css.push(item.css)
        }
        return css.join(" ");
    }

}
